import { createContext, useContext } from 'react';

/**
 * True while the builder shows an agent's play with Agents unlocked, provided
 * by `AdvancedBuilderContainer`. An agent's play finds its leads per schedule
 * period; a library play keeps today's builder. Its own module, like `BuilderGraphContext`, so step bodies
 * and cards read it without an import cycle through the container. False
 * without a provider (tests, isolated renders, the library builder).
 */
export const AgentPlayContext = createContext(false);

export function useAgentPlay(): boolean {
  return useContext(AgentPlayContext);
}

/**
 * The id of the agent that owns the play, provided beside `AgentPlayContext`
 * wherever the host knows it: the builder on an agent's play and the agent's
 * app trigger form. A cleanup play's step bodies read the agent's CRM scan and
 * its CRM write policy through it. Null without a provider, and on a library
 * play.
 */
export const PlayAgentIdContext = createContext<string | null>(null);

export function usePlayAgentId(): string | null {
  return useContext(PlayAgentIdContext);
}

/** Actual selected play in an agent trigger form, which has no saved builder. */
export const PlayTargetIdContext = createContext<string | null>(null);

export function usePlayTargetId(): string | null {
  return useContext(PlayTargetIdContext);
}

/** The server-proved pending proposal displayed by this owned Agent builder. */
export const PlayProposalIdContext = createContext<string | null>(null);
export function usePlayProposalId(): string | null {
  return useContext(PlayProposalIdContext);
}
